import { HttpHeaders, HttpParams } from "@angular/common/http";
import { HttpParamsOptions } from "@angular/common/http/src/params";

export class CommonHttpOption {
  headers = new HttpHeaders({
    "Content-Type": "application/json"
  })
    .append("Authorization", "Bearer " + localStorage.getItem("token"))
    .append(
      "HID",
      localStorage.getItem("holdingCode")
        ? localStorage.getItem("holdingCode")
        : ""
    )
    .append(
      "CID",
      localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : ""
    )
    .append(
      "BID",
      localStorage.getItem("branchCode")
        ? localStorage.getItem("branchCode")
        : ""
    );

  params = new HttpParams();
  paginator(page, pageSize, orderBy = null, orderDesc = false) {
    var paging: any;
    if (orderBy)
      paging = { xPage: page, xPageSize: pageSize, xOrderBy: orderBy, xOrderDesc: orderDesc };
    else
      paging = { xPage: page, xPageSize: pageSize, xOrderDesc: orderDesc };
    const params: HttpParamsOptions = {
      fromObject: paging
    } as HttpParamsOptions;
    return new HttpParams(params);
  }
}

// xPage
// integer($int32)
// (query)
// xPageSize
// integer($int32)
// (query)
// xOrderBy
// string
// (query)
// xOrderDesc
// boolean
